<div class="aplayer-controller">
  <slot name="progress" />
  <div class="aplayer-time">
    <slot name="time" />
    <slot name="volume" />
    <slot name="mode" />
    <slot name="menu" />
  </div>
</div>



// WEBPACK FOOTER //
// ./src/components/Controller/src/Controller.html